// removed by extract-text-webpack-plugin
module.exports = {"searchWrapper":"_7le0WdyeEgm_irJVkaV78","icon":"_1YHShgmS0aHAK4_mvkaebJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput/SearchInput.scss
// module id = 1776
// module chunks = 0